import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { LEADERBOARD_URL } from "./apiEndpoints";
import type { ApiResponse, LeaderboardItem } from "./types";

type UseGetLeaderboardOptions = Omit<
  UseGetServiceOptions<ApiResponse<LeaderboardItem[]>>,
  "route" | "queryKey"
>;

export const useGetLeaderboard = (options?: UseGetLeaderboardOptions) =>
  useGetService<ApiResponse<LeaderboardItem[]>>({
    route: LEADERBOARD_URL,
    queryKey: ["dq-dashboard", "leaderboard"],
    retry: false,
    ...(options ?? {}),
  });
